import type { MutableRefObject } from 'react';

import { Box } from '@packages/fenrir/components';

type Props = {
  children: React.ReactNode;
  boxRef: MutableRefObject<HTMLDivElement | null>;
};

export const RiskManagementTableWrapper = ({ children, boxRef }: Props) => (
  <Box
    sx={{
      position: 'relative',
      overflow: 'hidden',
      height: '60vh',
      mt: 3,
      minHeight: '800px',
    }}
    ref={boxRef}
  >
    {children}
  </Box>
);
